import _ from 'lodash'
import { httpClient } from '~/utils/axios'
import { dayjsTz as dayjs } from '~/utils/dayjs'

const getDefaultState = () => {
  return {
    news: [],
    manuals: []
  }
}

export const state = () => getDefaultState()
export const mutations = {
  reset(state) {
    Object.assign(state, getDefaultState())
  },

  setDocs(state, payload) {
    let lists = []
    payload.results.forEach(rl => {
      let title = rl.properties.タイトル.title[0].plain_text
      let created_time = rl.properties.作成日時.created_time
      let last_edited_time = rl.properties.最終更新日時.last_edited_time
      let public_date = rl.properties.公開日.date
        ? rl.properties.公開日.date.start
        : null
      let public_url = rl.public_url
      let public_is_new = dayjs(public_date).isAfter(dayjs().subtract(2, 'd'))
        ? true
        : false
      let updated_is_new = dayjs(last_edited_time).isAfter(
        dayjs().subtract(2, 'd')
      )
        ? true
        : false
      let list = {
        // ページID。お知らせの既読管理（store/announcement の readIds）のキーに使う
        id: rl.id,
        title: title,
        public_url: public_url,
        created_time: created_time,
        last_edited_time: last_edited_time,
        public_date: public_date,
        public_is_new: public_is_new,
        updated_is_new: updated_is_new
      }
      lists.push(list)
    })

    if (payload.tag === 'ガイド') {
      lists = _.sortBy(lists, ['title'])
      state.manuals = lists
    } else {
      lists = _.sortBy(lists, ['public_date']).reverse()
      state.news = lists
    }
  }
}
export const getters = {}

// fetchNewsIfNeeded の取得中リクエスト（重ねて呼ばれたときに1本にまとめる）
let newsRequest = null

export const actions = {
  // ヘッダーのベル（未読数）用にリリースノートを裏で取る。
  // 取得済みなら何もしない。ローディング表示・エラーアラートには触らない
  // （画面操作を邪魔しない。失敗したらベルに Notion 分が乗らないだけ）
  fetchNewsIfNeeded(context) {
    if (context.state.news && context.state.news.length > 0)
      return Promise.resolve()
    if (newsRequest) return newsRequest
    const tag = 'リリース'
    newsRequest = httpClient
      .post(`/public/notion.json`, { tag: tag })
      .then(res => {
        if (res && res.data && res.data.status === 'success') {
          context.commit('setDocs', {
            tag: tag,
            results: res.data.body.results
          })
        }
      })
      .catch(() => {})
      .finally(() => {
        newsRequest = null
      })
    return newsRequest.then(() => undefined)
  },
  async getDocs(context, tag) {
    await httpClient
      .post(`/public/notion.json`, {
        tag: tag
      })
      .then(async res => {
        if (res.data.status === 'success') {
          context.commit('setDocs', {
            tag: tag,
            results: res.data.body.results
          })
        } else {
          window.storeCtl.commit('alert/setError', res.data.message)
        }
      })
      .finally(() => {
        window.storeCtl.commit('loading/stop')
      })
  }
}
